import './IFrame.css'
import * as React from 'react';
import {LinearProgress} from "@mui/material";

class IFrame extends React.Component {
  frame = React.createRef();

  componentDidMount() {
    this.interval = setInterval(this.updateComponent.bind(this), 1000);
    this.src = this.props.src;
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  updateComponent() {
    let scrollHeight = this.frame.current?.contentWindow?.document?.body?.scrollHeight;

    if (this.props.autoHeight && scrollHeight) {
      this.frame.current.style.height = scrollHeight + 'px';
    }

    let location = this.frame.current?.contentWindow?.location;
    let currentSrc = location?.href;

    if (currentSrc && currentSrc !== this.src && (location.protocol === "http:" || location.protocol === "https:")) {
      this.src = currentSrc;

      if (this.props.onLocationChange) {
        this.props.onLocationChange(location);
      }
    }
  }

  render() {
    return (
      <div className={"iframe"}>
        <div className={"iframe-loader"}>
          <LinearProgress/>
        </div>
        <iframe ref={this.frame} frameBorder={0} title={this.props.title} src={this.props.src}
                className={this.props.className} scrolling="no" onLoad={this.updateComponent.bind(this)}/>
      </div>
    );
  }
}

export default IFrame;
